<template>
    <div>
        <breadCrumb 
            :icon="'fa-file-invoice-dollar'"
            :category="$t(`sideNav.navSalonReport`)"
            :subCategory="$t(`subMenu.salon_report_commission`)"
            :subSubCategory="''">
        </breadCrumb>
        <ul class="nav nav-tabs nav-tabs-clean px-3 px-sm-5 mt-3" role="tablist">
            <li class="nav-item" v-for="t in $i18n.messages[$i18n.locale].tab.reportCommissionTabs" :key="t.id">
                <a class="nav-link bg-transparent fs-lg fw-400" :class="{'active': selectedTab == t.id}" @click="selectedTab = t.id">{{t.text}}</a>
            </li>
        </ul>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4" :class="{'border-bottom-0': selectedTab != 'item'}">
                    <commissionFilter ref="commissionFilter" :selectedTab="selectedTab" :arrOrderID="arrOrderID" :arrReceiptID="arrReceiptID" @filterCommission="filterCommission"></commissionFilter>
                </div>
                <div class="panel-container show">
                    <div class="panel-content">
                        <div class="tab-content mt-5">
                            <commissionCategory ref="commissionCategory" class="tab-pane" :class="{'active': selectedTab == 'category'}" :selectedPaymentFilter="selectedPaymentFilter" :staffObj="staffObj" :selectedCategory="selectedCategory"></commissionCategory>
                            <commissionType ref="commissionType" class="tab-pane" :class="{'active': selectedTab == 'type'}" :staffObj="staffObj"></commissionType>
                            <commissionItem ref="commissionItem" class="tab-pane" :class="{'active': selectedTab == 'item'}" @getCommissionItems="filterCommission"></commissionItem>
                            <commissionStaff ref="commissionStaff" class="tab-pane" :class="{'active': selectedTab == 'staff'}" @getCommissionItems="filterCommission"></commissionStaff>
                        </div>
                    </div>
                </div> 
            </div>
            <div v-if="windowWidth > 992">
                    <div v-show="selectedTab != 'category' && totalEntries != 0" class="list-group scrollSpy-container">
                    <a v-for="(item, i) in scrollSpy" :key="i" type="button" class="btn btn-default waves-effect waves-themed text-dark text-right fs-xs pr-1 pl-1 mb-2" :href="'#rowGroup_' + selectedTab + '_' + item.id">{{item.title}}</a>
                </div>
            </div>
            <div v-else>
                <div v-show="selectedTab != 'category' && totalEntries != 0" class="list-group scrollSpy-container-mobile">
                    <a v-for="(item, i) in scrollSpy" :key="i" :href="'#rowGroup_' + selectedTab + '_' + item.id" class="btn btn-default btn-icon rounded-circle waves-effect waves-themed mb-2">
                        <i class="fal" :class="item.icon"></i>
                    </a>
                </div>
            </div>
            
        </div>
        <div id="loadingModal" :class="{'show': isModalShow}" class="modal fade">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content border-0 ">
                    <div class="modal-body text-center">
                        <div class="spinner-border text-light" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                        <div class="text-light mt-2">{{$t('message.data.fetching_wait')}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BreadCrumb from './../../Bread_Crumb'
import CommissionFilter from './Commission_Filter'
import CommissionCategory from './Commission_Category'
import CommissionType from './Commission_Type'
import CommissionItem from './Commission_Item'
import CommissionStaff from './Commission_Staff'

import moment from 'moment'
import _ from 'lodash';
import cst from './../../../../assets/js/dashboard/salonReport/salonReport'
import {handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
import {insertLeadingZero} from './../../../../assets/js/dashboard/utilities'

export default {
    name: 'reportCommission',
    components:{
        CommissionFilter,
        CommissionCategory, CommissionType, CommissionItem, CommissionStaff, BreadCrumb
    },
    data(){
        return{
            selectedTab: "category",
            staffCompletedItem: [], completedItem: [], filterObj: {}, isModalShow: false,
            totalEntries: 0,
            staffObj: {},
            arrOrderID: [{id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('subMenu.salon_report_order')})}], 
            arrReceiptID: [{id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('subMenu.salon_setting_receipt')})}],
            selectedCategory: -1,
            windowWidth: window.innerWidth,

            selectedPaymentFilter: 'all',
        }
    },
    computed:{
        scrollSpy(){
            let spy = cst.commissionReportItemType
            for(var i=0; i<spy.length; i++){
                spy[i].title = this.$i18n.t('salon_report.item_types.'+ spy[i].id)
            }
            return spy
        }
    },
    watch:{
        "$i18n.locale"(val){
            this.arrOrderID[0].text = this.$i18n.t('label.all', {'item': this.$i18n.t('subMenu.salon_report_order')})
            this.arrReceiptID[0].text = this.$i18n.t('label.all', {'item': this.$i18n.t('subMenu.salon_setting_receipt')})

            this.$refs.commissionFilter.setExportData(JSON.parse(JSON.stringify(this.completedItem)), this.selectedTab);
        },
        async selectedTab(value){
            this.$refs.commissionFilter.setOutletOptions(value)
            if(value != 'staff'){
                if(this.filterObj.date == this.$refs.commissionFilter.dateRange){
                    this.filterObj.outlet = this.$refs.commissionFilter.selectedOutlet
                    this.filterObj.staff = this.$refs.commissionFilter.selectedStaff
                    switch(value){
                        case"category":
                        this.$refs.commissionCategory.updateTable(this.completedItem, this.filterObj);
                        break;
                        case"type":
                        this.$refs.commissionType.updateTable(this.completedItem, this.filterObj);
                        break;
                        case"item":
                        this.$refs.commissionItem.updateTable(this.completedItem, this.filterObj);
                        break;
                    }
                    this.setStaffOption(this.completedItem, this.filterObj)
                }else{
                    var data = {
                        date: this.$refs.commissionFilter.dateRange,
                        order: this.$refs.commissionFilter.selectedOrderID,
                        receipt: this.$refs.commissionFilter.selectedReceiptID,
                        outlet: this.$refs.commissionFilter.selectedOutlet,
                        staff: this.$refs.commissionFilter.selectedStaff,
                        payment:  this.$refs.commissionFilter.selectedPayment,
                        type: this.$refs.commissionFilter.selectedType,
                        category: this.$refs.commissionFilter.selectedCategory, 
                        search: this.$refs.commissionFilter.searchCommission
                    }
                    this.filterCommission(data)
                }
                this.$refs.commissionFilter.setExportData(JSON.parse(JSON.stringify(this.completedItem)), value);
            }else{
                this.$refs.commissionFilter.selectedStaffOutlet = this.$refs.commissionFilter.staffOutlet[0]
                this.$refs.commissionFilter.selectedAllStaff = this.$refs.commissionFilter.allStaffs[0]
                this.$refs.commissionFilter.selectedPaymentTab = this.$refs.commissionFilter.paymentTabItems[0]

                var filterObj = {
                    date: this.filterObj.date,
                    staff: this.$refs.commissionFilter.selectedAllStaff,
                    outlet: this.$refs.commissionFilter.selectedStaffOutlet,
                    payment: this.$refs.commissionFilter.selectedPaymentTab
                }
                
                this.filterCommission(filterObj)
            }
            
        }
    },
    methods:{
        async filterCommission(filterObj){
            let DATE_QUERY = "?startDate=" + moment(filterObj.date.startDate).format(this.$msg.CST.DATE_FORMAT) + "&endDate=" + moment(filterObj.date.endDate).format(this.$msg.CST.DATE_FORMAT);
            let OUTLET_QUERY = filterObj.outlet.id == "all" ? "" : "&outletID=" + filterObj.outlet.id 

            let STAFF_QUERY = ""
            if(filterObj.staff.staffID == ""){
                STAFF_QUERY= "";
            }else if(filterObj.staff.staffID == "no"){
                STAFF_QUERY = "&noStaff=1";
            }else{
                STAFF_QUERY= "&staffID=" + filterObj.staff.staffID;
            }
            let PAYMENT_QUERY = filterObj.payment.id == "all" || filterObj.payment.id == "" ? "" : "&redeem=" + filterObj.payment.id

            this.selectedPaymentFilter = filterObj.payment.id
            
            let ORDER_QUERY = ""
            let RECEIPT_QUERY = ""
            let SEARCH_QUERY = ""
            if(this.selectedTab != 'staff'){
                ORDER_QUERY = filterObj.order.id == "all" ? "" : "&orderID=" + filterObj.order.id
                RECEIPT_QUERY = filterObj.receipt.id == "all" ? "" : "&receiptID=" + filterObj.receipt.id
                SEARCH_QUERY = filterObj.search == "" ? "" : "&search=" + filterObj.search
            }
            

            let TYPE_QUERY = ""
            let CATEGORY_QUERY = ""
            if(this.selectedTab == 'type'){
                TYPE_QUERY = filterObj.type == "all" ? "" : "&type=" + filterObj.type
            }else if(this.selectedTab == 'category'){
                CATEGORY_QUERY = filterObj.category == -1 ? "" : "&category=" + filterObj.category
            }
            
             

            let QUERY_STRING = DATE_QUERY + OUTLET_QUERY + STAFF_QUERY + PAYMENT_QUERY + ORDER_QUERY + RECEIPT_QUERY + TYPE_QUERY + CATEGORY_QUERY + SEARCH_QUERY
            
            this.isModalShow = true
            var result = await this.getCommissionItems(QUERY_STRING)
            if(filterObj.payment.id == ""){
                result = result.filter(obj=> obj.redeem == "")
            }
            
            this.$refs.commissionItem.updateTable(result, filterObj);
            this.$refs.commissionType.updateTable(result, filterObj);
            this.$refs.commissionCategory.updateTable(result, filterObj);

            if(this.selectedTab == 'staff'){
                this.staffCompletedItem = result
                this.$refs.commissionStaff.rearrangeCommissionItems(result, filterObj);
            }else{
                this.filterObj = filterObj
                this.staffObj = filterObj.staff
                this.completedItem = result
                
                if(filterObj.staff.staffID == ""){
                    this.setStaffOption(this.completedItem, this.filterObj)
                }else{
                    var staffOption = this.$refs.commissionFilter.staffs
                    this.$refs.commissionFilter.staffs = staffOption.filter(o => o.outletID == this.filterObj.outlet.id)
                }
            }
            
            this.setOrderReceiptOption(result)
            this.$refs.commissionFilter.setExportData(JSON.parse(JSON.stringify(result)), this.selectedTab);
            this.isModalShow = false
        },
        setOrderReceiptOption(result){
            for(var i=0; i<result.length; i++){
                let exists = this.arrOrderID.some(orderID => orderID.id === result[i].orderID);
                if(!exists){
                    this.arrOrderID.push({id: result[i].orderID, text: insertLeadingZero(result[i].orderID)})
                }
            }
            for(var k=0; k<result.length; k++){
                let exist = this.arrReceiptID.some(receiptID => receiptID.id === result[k].receiptID);
                if(!exist){
                    this.arrReceiptID.push({id: result[k].receiptID, text: insertLeadingZero(result[k].receiptID)})
                }
            }
        },
        setStaffOption(result, filterObj){
            var outlets = JSON.parse(this.$store.state.outlets);
            var outlet = [{id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')})}]
            outlet.push(...outlets);
            
            var staffOptions = []
            if(filterObj.outlet.id == "all"){
                var group = _.groupBy(result, "outletID")
                for(var i in group){
                    var staffs = [{staffID: "", name: this.$i18n.t('label.all', {'item': this.$i18n.t('subMenu.salon_setting_staff')}), outletID: parseInt(i)}]
                    for(var j=0; j<group[i].length; j++){
                        var groupStaffs = group[i][j].staffs
                        if(groupStaffs.length != 0){
                            groupStaffs.filter( o => !staffs.some(obj => obj.staffID === o.staffID))
                            .forEach(o => {
                                staffs.push({
                                    staffID: o.staffID,
                                    name: o.name,
                                    outletID: parseInt(i)
                                });
                            });
                        }
                    }
                    staffs.push({staffID: "no", name: this.$i18n.t('label.no', {'item':  this.$i18n.t('table.header.staff')}), outletID: parseInt(i)})
                    group[i] = staffs
                }
                staffOptions = outlet.slice()
                for(var k=0; k<staffOptions.length; k++){
                    for(var l in group){
                        if(parseInt(l) == staffOptions[k].id){
                           staffOptions[k].staff = group[l]
                        }
                    }
                    if(!('staff' in staffOptions[k])){
                        staffOptions[k].staff = [{staffID: "", name: this.$i18n.t('label.all', {'item': this.$i18n.t('subMenu.salon_setting_staff')}), outletID: staffOptions[k].id}, {staffID: "no", name: this.$i18n.t('label.no', {'item':  this.$i18n.t('table.header.staff')}), outletID: staffOptions[k].id}]
                    }
                    staffOptions[k].outletID = staffOptions[k].id
                    staffOptions[k].outlet  = staffOptions[k].text
                    delete staffOptions[k].id
                    delete staffOptions[k].text
                }
            }else{
                var _staffs = []
                if(this.selectedTab != 'staff'){
                    _staffs = [{staffID: "", name: this.$i18n.t('label.all', {'item': this.$i18n.t('subMenu.salon_setting_staff')}), outletID: parseInt(filterObj.outlet.id)}]
                }

                for(var m=0; m<result.length; m++){
                    var _groupStaffs = result[m].staffs

                    if(_groupStaffs.length != 0){
                        _groupStaffs.filter(o => !_staffs.some(obj => obj.staffID === o.staffID))
                        .forEach(o => {
                            _staffs.push({
                                staffID: o.staffID,
                                name: o.name,
                                outletID: parseInt(filterObj.outlet.id)
                            });
                        });
                    }
                }
                _staffs.push({staffID: "no", name: this.$i18n.t('label.no', {'item':  this.$i18n.t('table.header.staff')}), outletID: parseInt(filterObj.outlet.id)})
                staffOptions.push({
                    outletID: filterObj.outlet.id,
                    outlet: filterObj.outlet.text,
                    staff: _staffs
                })
            }  
            this.$refs.commissionFilter.staffs = staffOptions
            this.$refs.commissionFilter.selectedStaff = staffOptions[0].staff[0]
        },
        async getCommissionItems(strFilter){
            let $vm = this
            let url = this.$api.REPORT_COMPLETED + strFilter
            var result = [];
            await this.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()}
            })
            .then(function(response) {
                result = response.data.result;
                $vm.totalEntries = response.data.count;
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result;
        },

        resize(e){
            this.windowWidth = window.innerWidth
        }
    },
    created() {
        window.addEventListener("resize", this.resize);
    },
    destroyed() {
        window.removeEventListener("resize", this.resize);
    },
}
</script>
<style scoped>
.nav-link{
    cursor: pointer;
}
.show{
    display: block;
}
.modal-content{
    background: transparent;
    box-shadow: none;
}
.scrollSpy-container{
    position: fixed;
    top: 40%;
    margin-left: -5em;
}
.scrollSpy-container > a{
    min-width: 6.5em;
}
.scrollSpy-container-mobile{
    position: fixed;
    top: 40%;
    margin-left: -7%;
}
</style>